import { Injectable } from '@angular/core'
import { SeFeApiService } from 'se-fe-api'

@Injectable({
  providedIn: 'root'
})
export class UserServiceApiService extends SeFeApiService {
  // we want to go directly to user-service, not via se-api,
  // because the data stored in the auth_session is set on a user-service domain
  // and a separate auth_session is created for the se-api domain
  protected baseUrl(): string {
    return this.domainEnvironmentService.getUrl('userService')
  }
}
